// @givmo/app-admin — app-level constants.
//
// The README "Per-app X-Request-Id prefixes" table fixes the admin prefix as `wb`; the placeholder
// module previously exported it as `REQUEST_ID_PREFIX`, kept here for the same contract. Typed as the
// api-client's `RequestIdPrefix` so a drift from the allowed set is a compile error.

import type { RequestIdPrefix } from '@givmo/api-client';
import { CLIENT_PLATFORMS } from '@givmo/observability';

/** Workspace package name. */
export const APP_NAME = '@givmo/app-admin' as const;

/** The admin app's X-Request-Id prefix (README contract; donate uses `dw`). */
export const ADMIN_REQUEST_ID_PREFIX: RequestIdPrefix = 'wb';

/** Back-compat alias for the placeholder export name. */
export const REQUEST_ID_PREFIX = ADMIN_REQUEST_ID_PREFIX;

/** The `X-Client-Platform` telemetry token for this app. */
export const ADMIN_CLIENT_PLATFORM = CLIENT_PLATFORMS.adminWeb;

/** External legal links surfaced in the app shell (parity with the Flutter `Consts.termsLink`/`policyLink`). */
export const TERMS_URL = 'https://givmocharitable.org/terms' as const;
export const PRIVACY_URL = 'https://givmocharitable.org/privacy' as const;

/**
 * The consumer app's store listings — the EP-WEB8 announcement template's, which moved to the employer
 * module with the invites tab (EP-MNT3). Re-exported so this path keeps answering.
 */
export { APP_STORE_URL, PLAY_STORE_URL } from '@givmo/employer-module/lib/constants';

// No `SUPPORT_URL` here on purpose: help/support is the IN-APP `/support` route (both the sidebar
// entry and the top-bar help control link to it). The former external destination,
// `https://www.givmo.io/support`, 404s on the live marketing site (EP-FIX6) — do not reintroduce it.
